import React from 'react';

import {Link} from '../../lib/routes';
import {SECTIONS, SectionKey} from '../../lib/seo';

import css from './not-found.module.css';

const SECTION_LINKS: SectionKey[] = ['classes', 'species', 'origins', 'feats', 'spells', 'items', 'monsters', 'rules'];

/** Содержимое страницы 404: и по адресу /404, и для несуществующих адресов внутри разделов */
export const NotFound: React.FC = () => (
	<div className={css.wrapper}>
		<h1>Страница не найдена</h1>
		<p>Такой страницы на сайте нет: она могла переехать, или в адресе опечатка.</p>
		<ul className={css.sections}>
			{SECTION_LINKS.map((section) => (
				<li key={section}>
					<Link route={SECTIONS[section].route}>{SECTIONS[section].name}</Link>
				</li>
			))}
		</ul>
	</div>
);
